module.exports = __webpack_public_path__ + "img/oral-b.a101a6c.png";